/*
 * lazy-images.js — minimal image lazy-loader
 * ---------------------------------------------------------------------------
 * Restores the `data-src`/`data-srcset` -> `src`/`srcset` swap that used to be
 * performed by the removed wnw-optimization.js. The theme (and legacy rich-text
 * content) still renders images with `class="lazy2"` (also lazy22 / lazy3) and
 * backgrounds with `class="lazybg"` (also lazybg2 / lazybg25), whose real URLs
 * live in data-* attributes. Without this swap those images never load.
 *
 * Unlike the old WNW loader, which only revealed images after the first
 * scroll/mouse/touch event (so images stayed blank for visitors who didn't
 * interact), this uses IntersectionObserver: in-view images load immediately
 * and below-the-fold images load as they approach the viewport.
 *
 * lazysizes (lazyload.js) handles class `lazyload`; this handles `lazy2`/`lazy22`/
 * `lazy3` and the `lazybg*` backgrounds, which lazysizes does not.
 */
(function () {
  'use strict';

  var IMG_SELECTOR = '.lazy2, .lazy22, .lazy3';
  var BG_SELECTOR = '.lazybg, .lazybg2, .lazybg25';
  var IMG_CLASSES = ['lazy2', 'lazy22', 'lazy3'];
  var BG_CLASSES = ['lazybg', 'lazybg2', 'lazybg25'];
  var isMobile = (window.innerWidth || document.documentElement.clientWidth) < 600;

  function revealImage(img) {
    var srcset = img.getAttribute('data-srcset');
    var src = (isMobile && img.getAttribute('data-mobsrc')) || img.getAttribute('data-src');
    if (srcset) img.setAttribute('srcset', srcset);
    if (src) img.setAttribute('src', src);
    IMG_CLASSES.forEach(function (c) { img.classList.remove(c); });
  }

  function revealBackground(el) {
    var style = (isMobile && el.getAttribute('data-mobstyle')) || el.getAttribute('data-style');
    if (style) el.setAttribute('style', style);
    BG_CLASSES.forEach(function (c) { el.classList.remove(c); });
  }

  function reveal(el) {
    if (el.tagName === 'IMG') {
      revealImage(el);
    } else {
      revealBackground(el);
    }
  }

  // No IntersectionObserver (very old browsers): load everything up front.
  if (!('IntersectionObserver' in window)) {
    var all = document.querySelectorAll(IMG_SELECTOR + ', ' + BG_SELECTOR);
    for (var i = 0; i < all.length; i++) reveal(all[i]);
    return;
  }

  var observer = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        reveal(entry.target);
        obs.unobserve(entry.target);
      }
    });
  }, { rootMargin: '600px 0px' });

  function observeAll(root) {
    var nodes = (root || document).querySelectorAll(IMG_SELECTOR + ', ' + BG_SELECTOR);
    for (var i = 0; i < nodes.length; i++) observer.observe(nodes[i]);
  }

  observeAll(document);

  // Pick up images injected after load (paginated sections, quick view, etc.).
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        for (var i = 0; i < m.addedNodes.length; i++) {
          var node = m.addedNodes[i];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(IMG_SELECTOR + ', ' + BG_SELECTOR)) observer.observe(node);
          if (node.querySelectorAll) observeAll(node);
        }
      });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
